import { render, staticRenderFns } from "./Ability.vue?vue&type=template&id=5b976786&scoped=true"
import script from "./Ability.vue?vue&type=script&lang=js"
export * from "./Ability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b976786",
  null
  
)

export default component.exports